<template>
  <div>
    <div class="ticket_info_user_title ticket_icon">
      <div class="way_title_left">
        <img :src="staticAssets.ImgObj.ticket_address" alt />
        <span>{{TLang('取票地址','my')}}</span>
      </div>
    </div>
    <div class="ticket_info_user_table">
      <div class="ticket_info_empty" v-if="this.ticketLocationData.length < 1">
        {{TLang('暂无地址','my')}}
      </div>
      <div class="ticket_self_help" v-if="self_type == 2">
        <div
          v-for="(card_item, cIndex) in ticketLocationData"
          :key="`card${cIndex}`"
          class="ticket_info_user_item"
          v-show="
            (!select_click_flag && cIndex == 0) ||
              select_click_flag || 
              detail_page == 1
          "
        >
          <div class="info_left">
            <img
              class="user_item_location"
              :src="staticAssets.ImgObj.location_address"
              alt
            />
            <div class="info_left_top">
              <span class="user_item_tel_nomal">{{ card_item.address }}</span>
            </div>
            <div class="info_left_bottom">
              <span style="margin-right: 24px;">
                {{ card_item.businessHours }}
              </span>
              <span>{{ card_item.tel }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="ticket_self_machine" v-if="self_type == 1">
        <div
          v-for="(card_item, cIndex) in ticketLocationData"
          :key="`card${cIndex}`"
          style="height:44px!important"
          class="ticket_info_user_item"
        >
          <div class="info_left">
            <img
              class="user_item_location"
              :src="staticAssets.ImgObj.location_address"
              alt
            />
            <div class="info_left_top" style="margin:0;margin-left:16px;">
              <span class="user_item_tel_nomal"
                >{{ card_item.pointAddr }}{{ card_item.pointName }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="ticket_info_location_more"
        @click="getLocationMore"
        @mouseover="moreMouseEnter"
        @mouseleave="moreMouseOut"
        :class="{ locaton_more_checked: hover_click_flag }"
        v-if="all_location_address.length > 1 && detail_page != 1"
      >
        <span>{{ select_click_flag ? TLang('收起地址', 'my') : TLang('更多地址', 'address') }}</span>
        <img
          :src="
            select_click_flag
              ? hover_click_flag
                ? staticAssets.ImgObj.location_arrow_top
                : staticAssets.ImgObj.location_arrow_hover
              : hover_click_flag
              ? staticAssets.ImgObj.select_arrow_hover
              : staticAssets.ImgObj.select_arrow_bottom
          "
          alt
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TicketLocation",
  data() {
    return {
      select_click_flag: false, //是否点击下拉更多地址
      hover_click_flag: false, //下拉 hover 更多地址
      all_location_address: this.locationAll,
      ticketLocationData: this.locationSource,
      self_type: this.type_ticket, //判断是否是自助取票机取票
      detail_page: this.detail_flag //是否是订单详情页面
    };
  },
  props: ["locationSource", "locationAll", "type_ticket", "detail_flag"],
  watch: {
    locationSource: {
      handler: function(newVal) {
        this.ticketLocationData = newVal;
      },
      deep: true,
      immediate: true
    },
    locationAll: {
      handler: function(newVal) {
        this.all_location_address = newVal;
      },
      deep: true,
      immediate: true
    },
    type_ticket(val) {
      this.self_type = val;
    },
    detail_flag(val) {
      this.detail_page = val;
    }
  },
  components: {},
  beforeCreate() {},
  created() {},
  // 移除滚动事件
  destroyed() {},
  computed: {},
  methods: {
    // 更多地址 mouseOver 事件
    moreMouseEnter() {
      this.hover_click_flag = true;
    },
    // 更多地址 mouseLeaver 事件
    moreMouseOut() {
      this.hover_click_flag = false;
    },
    //查看更多地址
    getLocationMore() {
      this.select_click_flag = !this.select_click_flag;
      if (this.select_click_flag) {
        this.ticketLocationData = this.all_location_address;
      } else {
        this.ticketLocationData =
          this.self_type == 1
            ? this.all_location_address.length > 3
              ? this.all_location_address.slice(0, 3)
              : this.all_location_address
            : this.all_location_address.slice(0, 1);
      }
    }
  }
};
</script>

<style scoped lang="less">
.ticket_info_user_table {
  margin: 18px 0 8px 32px;
  /deep/ .user_ticket_info .el-form-item {
    margin: 24px 0 0 4px;
  }
  /deep/ .user_ticket_info .el-form-item__label {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  /deep/ .user_ticket_info .el-form-item__content {
    width: 320px;
  }
  /deep/ .user_ticket_info .el-input__inner {
    width: 320px;
    height: 32px;
  }
  .user_ticket_info {
    .code_verification {
      color: rgba(17, 17, 17, 1);
    }
  }
  .ticket_info_empty {
    font-size: 12px;
    color: rgba(204, 204, 204, 1);
    line-height: 16px;
    margin: 1px 0 24px;
  }

  .ticket_info_user_item {
    .drama_wrap_attr(100%, 50px, 50px, 14px, rgba(17, 17, 17, 1), inherit);
    background: rgba(250, 250, 250, 1);
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info_left {
      align-items: center;
      display: flex;
    }
    .operate_right {
      margin-right: 20px;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
        display: inline-block;
        span {
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
      .active_edit {
        span {
          color: rgba(61, 150, 226, 1);
        }
      }
      .edit_left {
        margin-right: 30px;
      }
      img {
        width: 16px;
        height: 16px;
        margin: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
        margin-top: 0px;
      }
    }
    span {
      display: inline-block;
    }
    .user_item_no {
      .drama_wrap_attr(20px, 20px, 20px, 12px, rgba(255, 255, 255, 1), inherit);
      margin-left: 20px;
      text-align: center;
      background: rgba(204, 204, 204, 1);
    }
    .user_itm_name {
      width: 68px;
      margin-left: 28px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .user_item_line {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 32px;
    }
    .user_item_line_id {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 28px;
    }
    .user_item_card {
      margin-right: 24px;
    }
    .user_item_tel {
      font-weight: bold;
    }
  }
}
.locaton_more_checked {
  span {
    color: rgba(61, 150, 226, 1);
  }
}
.ticket_info_user_title {
  display: flex;
  justify-content: space-between;
  .way_title_left {
    display: flex;
    align-items: center;
  }
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ticket_icon span {
  .drama_font_style(inherit, 500, 16px, 21px);
  display: inline-block;
  margin-left: 15px;
  color: rgba(17, 17, 17, 1);
  height: 21px;
}
.ticket_icon i {
  .drama_font_style(normal, 500, 12px, 16px);
  margin-left: 4px;
  color: rgba(102, 102, 102, 1);
}
.ticket_info_user_table {
  margin-left: 28px !important;
  .ticket_info_user_item {
    height: 68px !important;
    .info_left {
      height: 100%;
      width: 100%;
      position: relative;
      flex-direction: column;
      padding-left: 44px;
      align-items: start !important;
      justify-content: center;
      .user_item_location {
        position: absolute;
        left: 16px;
        top: 12px;
        width: 20px;
        height: 20px;
      }
      .info_left_top,
      .info_left_bottom {
        display: flex;
        line-height: 16px;
      }
      .info_left_top {
        margin-bottom: 12px;
      }
      .info_left_top span {
        color: rgba(51, 51, 51, 1);
        font-weight: 500;
        line-height: 16px;
      }
      .info_left_bottom span {
        color: rgba(102, 102, 102, 1);
        line-height: 16px;
      }
    }
  }
}
.ticket_info_location_more {
  width: 88px;
  cursor: pointer;
  span {
    display: inline-block;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  img {
    width: 12px;
    height: 12px;
    margin-bottom: 2px;
    margin-left: 8px;
    display: inline-block;
    vertical-align: middle;
  }
}
.locaton_more_checked {
  span {
    color: rgba(61, 150, 226, 1);
  }
}
</style>
